import React from 'react';

const OrgCardSkeleton: React.FC = () => {
  return (
    <div className="rounded-2xl p-2 transition-all duration-300 ease-in-out hover:-translate-y-1 hover:shadow-xl hover:scale-[1.01] active:scale-95 cursor-pointer">
      <div className="block w-full h-full">
        {/* Organization Badge and Info Skeleton */}
        <div
          className="flex items-start gap-3 mb-4 rounded-2xl w-full p-[1px] animate-pulse"
          style={{
            background:
              'linear-gradient(to right, #EBEBEB 30%,#E6E6E6 30%,#fff 100%)'
          }}
        >
          <div
            className="w-[138px] h-[138px] bg-gray-200 rounded-2xl border-2 overflow-hidden border-white"
            style={{ boxShadow: '0px 8.02px 23.2px rgba(66, 84, 152, 0.1)' }}
          />

          <div className="self-center flex flex-col text-gray-600 text-sm tracking-[-0.02em] mb-2 space-y-2">
            <div className="h-4 bg-gray-200 rounded w-20" />
            <div className="h-4 bg-gray-200 rounded w-24" />
          </div>
        </div>

        {/* Organization Status and Actions Skeleton */}
        <div className="flex items-start">
          <div className="flex flex-col justify-center gap-1">
            <div className="h-6 bg-gray-200 rounded w-32 mb-1" />
            <div className="flex flex-col gap-2 text-sm font-normal">
              <div className="h-4 bg-gray-200 rounded w-20" />
            </div>
          </div>

          <div className="ml-auto">
            <div className="ml-1 px-4 py-2 h-8 w-12 bg-gray-200 rounded-full" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrgCardSkeleton;
